<template>
  <div class="home ocsMainPage">

    <!-- Hero -->
    <Splash
      :acf="acf"
      :id="wpPageId"
    />

    <!-- Main Home Intro -->
    <template v-if="wpPageId === 4">
      <section class="introSection">
        <div class="container">
          <div class="introAccent"></div>

          <h3 class="textSub">
            OCS Sport provides an integrated Tour Management System covering
            player administration, tournament entries, draws, live scoring,
            results, rankings, prize money, statistics, websites and mobile
            applications for professional golf tours.
          </h3>
        </div>
      </section>
    </template>


    <!-- Primary Section -->
    <template
      v-if="
        wpPageId === 4 ||
        wpPageId === 201 ||
        wpPageId === 158 ||
        wpPageId === 12
      "
    >
      <section class="secPad sectionWhite">
        <SectionBlock
          :acf="acf"
          :id="wpPageId"
          sec="right"
        />
      </section>
    </template>


    <!-- Grey Section -->
    <template
      v-if="
        wpPageId === 4 ||
        wpPageId === 201 ||
        wpPageId === 158
      "
    >
      <section class="secPad sectionGrey">
        <SectionBlock
          :acf="acf"
          :id="wpPageId"
          sec="left"
        />
      </section>
    </template>


    <!-- Additional Section -->
    <template
      v-if="
        wpPageId === 201 ||
        wpPageId === 158
      "
    >
      <section class="secPad sectionWhite">
        <SectionBlock
          :acf="acf"
          :id="wpPageId"
          sec="right_1"
        />
      </section>
    </template>


    <!-- Tour Management Additional Section -->
    <template v-if="wpPageId === 201">
      <section class="secPad sectionGrey">
        <SectionBlock
          :acf="acf"
          :id="wpPageId"
          sec="left_1"
        />
      </section>
    </template>

    <!-- Event management -->
    <template  v-if="wpPageId === 4">
        <section class="secPad sectionWhite centreSection">
          <SectionEvent
            :acf="acf"
            :id="wpPageId"
            sec="centre"
          />
        </section>
    </template>

    <!-- Apps management -->
    <template  v-if="wpPageId === 4">
        <section class="secPad sectionGrey centreSection">
          <SectionApp
            :acf="acf"
            :id="wpPageId"
            sec="centre"
          />
        </section>
    </template>



    <!-- OCS Systems -->
    <template v-if="wpPageId === 201">
      <section class="systemsSection">
        <OCS />
      </section>
    </template>


    <!-- Contact / Venue Form -->
    <template
      v-if="
        wpPageId === 158 ||
        wpPageId === 14
      "
    >
      <section class="formSection">
        <Form :blue="acf.acf.golf_ball_blue" />
      </section>
    </template>


    <Footer />

  </div>
</template>

<script>
import axios from "axios";
import SectionBlock from "@/components/sections.vue";
import SectionEvent from "@/components/sectionsEvent.vue";
import SectionApp from "@/components/SectionApp.vue";

import Splash from "@/components/splash.vue";
import Form from "@/components/form.vue";
import Footer from "@/components/footer.vue";
import OCS from "@/components/ocs-systems.vue";
export default {
  name: "Home",
  components: { Splash, SectionBlock, Footer, Form, OCS, SectionEvent, SectionApp },
  data: function() {
    return {
      acf: [],
    };
  },
  computed: {
    wpPageId: function(page) {
      if (this.$route.name === "home") page = 4;
      else if (this.$route.name === "tour-management") page = 201;
      else if (this.$route.name === "venue-management") page = 158;
      else if (this.$route.name === "contact") page = 14;
      else if (this.$route.name === "about") page = 12;
      return page;
    },
  },
  mounted() {
    axios //add API Call
      .get(
        process.env.VUE_APP_API_URL + "/wp-json/wp/v2/pages/" + this.wpPageId
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => (this.acf = response.data)); //API data wanted pulled out
  },
};
</script>

<style scoped>

/* =========================================
   GLOBAL PAGE
========================================= */

.ocsMainPage {
  background: #ffffff;
}


/* =========================================
   INTRO
========================================= */

.introSection {
  padding: 85px 20px 80px;

  background: #ffffff;
}

.introSection .container {
  max-width: 1100px;
}

.introAccent {
  width: 55px;
  height: 4px;

  margin: 0 auto 30px;

  background: #00aeef;
}

.textSub {
  max-width: 1000px;

  margin: 0 auto !important;

  color: #20282f;

  font-size: 25px;
  line-height: 1.55;

  font-weight: 500;

  text-align: center;

  letter-spacing: -0.2px;
}


/* =========================================
   SECTIONS
========================================= */

.secPad {
  padding: 110px 40px;

  position: relative;
}

.sectionWhite {
  background: #ffffff;
}

.sectionGrey {
  background: #f4f6f8;
}


/* =========================================
   SECTION SEPARATORS
========================================= */

.sectionGrey::before {
  content: "";

  position: absolute;

  top: 0;
  left: 50%;

  width: 55px;
  height: 4px;

  transform: translateX(-50%);

  background: #00aeef;
}


/* =========================================
   SECTION CONTAINER
========================================= */

::v-deep .containerSep {
  max-width: 1400px;

  padding: 0;
}


/* =========================================
   WORDPRESS CONTENT
========================================= */

::v-deep h1.wp-block-heading {
  color: #111820;

  font-size: 42px;

  line-height: 1.2;

  font-weight: 700;
}

::v-deep h2.wp-block-heading {
  color: #00aeef;

  font-size: 21px;

  line-height: 1.4;

  font-weight: 700;

  letter-spacing: 0.3px;
}

::v-deep h3.wp-block-heading {
  color: #111820;

  font-size: 28px;

  line-height: 1.3;

  font-weight: 700;
}

::v-deep p {
  color: #515b63;

  font-size: 17px;

  line-height: 1.75;
}

::v-deep strong {
  color: #111820;
}


/* =========================================
   CTA
========================================= */

.cta {
  background-repeat: no-repeat;

  background-size: cover;

  background-position: center;
}

.ctaTop {
  padding: 25px;
}

.ctaPad {
  padding: 68px;
}


/* =========================================
   ALPS LOGO
========================================= */

.alpsLogoLink {
  display: flex;

  justify-content: center;
  align-items: center;

  padding: 20px;

  transition: transform 0.3s ease;
}

.alpsLogoLink:hover {
  transform: translateY(-4px);
}

.alpsLogo {
  max-width: 220px;

  height: auto;
}


/* =========================================
   CENTRE SECTION
========================================= */

.centreSection {
  text-align: center;
}


/* =========================================
   SYSTEMS
========================================= */

.systemsSection {
  background: #111820;
}


/* =========================================
   FORM
========================================= */

.formSection {
  background: #ffffff;

  padding: 0;
}


/* =========================================
   EXISTING RESPONSIVE ELEMENTS
========================================= */

.mobSize {
  display: none;
}


/* =========================================
   1260px
========================================= */

@media only screen and (max-width: 1260px) {

  .lgSize {
    display: none;
  }

  .mobSize {
    display: block;
  }

  .ctaPadMob {
    padding: 150px 254px 100px 60px;
  }

  .secPad {
    padding-left: 30px;
    padding-right: 30px;
  }

}


/* =========================================
   1024px
========================================= */

@media only screen and (max-width: 1024px) {

  .introSection {
    padding: 70px 30px;
  }

  .textSub {
    font-size: 22px;
  }

  .secPad {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  ::v-deep h1.wp-block-heading {
    font-size: 36px;
  }

  .ctaPadMob {
    padding: 115px 254px 100px 60px;
  }

}


/* =========================================
   768px
========================================= */

@media only screen and (max-width: 768px) {

  .introSection {
    padding: 55px 25px 60px;
  }

  .introAccent {
    margin-bottom: 22px;
  }

  .textSub {
    font-size: 19px;

    line-height: 1.6;
  }

  .secPad {
    padding: 60px 25px;
  }

  ::v-deep h1.wp-block-heading {
    font-size: 32px;
  }

  ::v-deep h2.wp-block-heading {
    font-size: 19px;
  }

  ::v-deep h3.wp-block-heading {
    font-size: 25px;
  }

  ::v-deep p {
    font-size: 16px;

    line-height: 1.7;
  }

  .ctaPadMob {
    padding: 125px 100px 100px 45px;
  }

}


/* =========================================
   480px
========================================= */

@media only screen and (max-width: 480px) {

  .introSection {
    padding: 45px 20px 50px;
  }

  .textSub {
    font-size: 17px;

    line-height: 1.65;
  }

  .secPad {
    padding: 45px 20px;
  }

  ::v-deep h1.wp-block-heading {
    font-size: 28px;
  }

  ::v-deep h2.wp-block-heading {
    font-size: 18px;
  }

  ::v-deep h3.wp-block-heading {
    font-size: 23px;
  }

  ::v-deep p {
    font-size: 15px;
  }

  .ctaPadMob {
    padding: 125px 35px 100px 45px;
  }

  .alpsLogo {
    max-width: 180px;
  }

}


/* =========================================
   SPLASH
========================================= */

::v-deep .splash {
  height: auto !important;
}

</style>
